<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row size="8" class="search-funnel-filter">
      <ion-col
        ><ion-searchbar (ionInput)="filterEvents($event)"></ion-searchbar
      ></ion-col>

      <ion-col size="2">
        <ion-button fill="clear" (click)="eventSort()">
          <ion-icon name="filter"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  @if (events.length === 0) {
    <div lines="none" class="empty-events-div">
      <ion-icon name="today-outline" class="no-events-icon"></ion-icon>
      <ion-label class="no-events-label">
        <h2>There are currently no local events.</h2>
      </ion-label>
    </div>
  }

  <ion-modal [isOpen]="image() !== undefined" (didDismiss)="closeModal()">
    <ng-template>
      <ion-content>
        <div (click)="closeModal()">
          <img [src]="this.image()" />
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>

  @for (item of events; track item.id) {
    <ion-card
      class="flex justify-between items-center"
    >
      <div class="flex flex-col w-3/4" (click)="goToDetails(item.id)">
        <ion-card-header class="w-full">
          <ion-card-title> {{ item.event.businessName }} </ion-card-title>
          <ion-card-subtitle> {{ item.event.title }} </ion-card-subtitle>
        </ion-card-header>

        <ion-card-content>
          @if (item.event.daysAvailable && item.event.daysAvailable.length > 0) {
            <div>
              Event Days: 
              {{ item.event.daysAvailable.join(', ') }}
            </div>
          } @else if (item.event.endDate) {
            Event Date:
            {{ item.event.endDate | date : "M/d/yyyy" }}
          }

          @if (item.event.startTime && item.event.endTime) {
            <div>
              Event Available From: 
              {{ item.event.startTime | date : "h:mm a" }}
              to
              {{ item.event.endTime | date : "h:mm a" }} 
            </div>
          } @else if (!item.event.startTime && item.event.endTime) {
              <div>
                End Time: 
                {{ item.event.endTime | date : "h:mm a" }}
              </div>
          } @else if (item.event.startTime && !item.event.endTime) {
              <div>
                Start Time: 
                {{ item.event.startTime | date : "h:mm a" }}
              </div>
          }

          @if (item.event.street && item.event.city && item.event.state && item.event.zipCode) {
            <div>
              Address:
              {{ item.event.street }}, {{ item.event.city }}, {{ item.event.state }} {{ item.event.zipCode }}
            </div>
          }

          @if (item.event.url && item.event.url !== '') {
          <div>
            <ion-button style="margin-top: 10px;" (click)="visitSite(item.event.url)">
              Visit Site
            </ion-button>
          </div>
          }
        </ion-card-content>
      </div>

      <div class="open-img" (click)="openModal(item)">
        <img class="max-h-14 mr-3" [src]="item.event.image?.[0]?.url" />
      </div>
    </ion-card>
  }
</ion-content>
